export default __webpack_public_path__ + "static/media/regulatory--buses-only--g2.38b5f21e.png";